// @flow
import * as React from 'react';

import { GoogleTagManager } from './GoogleTagManager';
import { Sentry } from './Sentry';
import { Cedexis } from './Cedexis';

export const PriorityThirdPartyScripts = () => (
  <React.Fragment>
    <GoogleTagManager />
    <Cedexis />
    <Sentry />
  </React.Fragment>
);
